import Route from "./Route";
import RouteV2 from "./RouteV2";

export const Timelines = {
    Route,
    RouteV2,
}